import ReactGA from "react-ga"

export function publishEvent(category: string, action: string, label?: string) {
  ReactGA.event({ category, action, label })
}

export function publishPageView(page: string) {
  ReactGA.pageview(page)
}
